import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { Modal, Tooltip, Alert } from 'bootstrap';
import { Fancybox } from "@fancyapps/ui";

import '../components/axios.js';
import Cookie from '../../../../dev/js/components/cookie.js';
import initPrototypes from '../components/prototypes.js';
import { getPublicUrl, detectLanguageParameter } from '../components/utils.js';
import RatingInputService from '../services/rating-input-service.js';
import ImageUploaderService from '../services/image-uploader-service.js';
import AuthService from '../services/auth-service.js';
import ReCaptchaService from '../services/recaptcha-service.js';

window.BS_VERSION = parseFloat(Tooltip.VERSION);
window.dataLayer = window.dataLayer || [];
window.Cookie = Cookie;
initPrototypes();

class Review {
	constructor() {
		window.authService = this.authService = new AuthService();
		this.authService.init();
		window.reCaptchaService = this.reCaptchaService = new ReCaptchaService();
		this.reCaptchaService.init(); // TODO: it can be deleted after public.js isn't used anymore

		this.originalLanguage = null;
		this.originalReviewText = '';
		this.isLoading = false;
		this.minTextLength = 40;
		this.reviewLanguage = detectLanguageParameter();
		this.form = document.getElementById('write-review');
		this.reviewInputSelector = 'textarea[name="text"]';
		this.titleInputSelector = 'input[name="title"]';
		this.btn = this.form.querySelector('.btn-submit');
		this.ratingInputService = new RatingInputService();
		this.imageUploaderService = new ImageUploaderService('.image-uploader:not(.d-none)', 10);

		this.ratingInputService.setupInputListener();
		this.initReviewWrite();
		this.formatOlderReview();

		Fancybox.bind("[data-fancybox]");

		const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
		const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));
	}

	initReviewWrite() {
		this.form.addEventListener('submit', (event) => this.handleSubmit(event));
		this.form.querySelector(this.reviewInputSelector).addEventListener('keyup', (event) => this.handleReviewChange(event));
		this.form.querySelector(this.titleInputSelector).addEventListener('click', (event) => this.handleReviewChanged(event));
		this.form.querySelector(this.reviewInputSelector + ' + .ai-badge').addEventListener('click', (event) => this.requestAiAssist(event));
		this.form.querySelector(this.titleInputSelector + ' + .ai-badge').addEventListener('click', (event) => this.requestAiSummarize(event));
		document.addEventListener('click', (event) => {
			if (event.target.closest('.review-exists .review-details a.btn-secondary')) {
				window.dataLayer.push({ event: 'review_keep' });
			}
		});

		if ('1' === this.form.dataset.recaptchaCheckbox) {
			this.reCaptchaService.runWithCheckbox('company_review_write', (token, withCheckbox = true) => {
				this.submitWithToken(token, withCheckbox);
			});
		}
	}

	formatOlderReview() {
		const content = document.querySelector('#older-review .ti-review-content');
		if (!content) {
			return;
		}

		content.TI_format().TI_shorten({
			'showLines': 5,
			'lessText': '<i class="ri-arrow-up-s-line" aria-hidden="true"></i> ' + document.body.dataset.lessText,
			'moreText': '<i class="ri-arrow-down-s-line" aria-hidden="true"></i> ' + document.body.dataset.moreText
		});
	}

	setHiddenInput(name, value) {
		let input = this.form.querySelector(`input[name="${name}"]`);
		if (!input) {
			input = document.createElement('input');
			input.type = 'hidden';
			input.name = name;
			this.form.appendChild(input);
		}

		input.value = value;
	}

	setUsedAi(value) {
		this.setHiddenInput('usedAi', value);
	}

	handleSubmit(event) {
		console.log('submit');

		if (this.isLoading) {
			console.log('already loading, skip submit');
			return;
		}

		event.preventDefault();
		event.stopPropagation();

		if (!this.authService.checkAuth()) {
			console.log('auth false');
			window.authService.showDialog();
			this.authService.on('closed', () => {
				console.log('closed event fired');

				if (this.authService.checkAuth()) {
					console.log('re-submit');
					this.submitWithCaptcha();
				} else {
					console.log('closed without auth');
					this.toggleLoadingAnimation(false);
				}
			});

			return;
		}

		this.submitWithCaptcha();
	}

	submitWithCaptcha() {
		this.toggleLoadingAnimation(true);

		this.reCaptchaService.runWithCaptcha('company_review_write', (token, withCheckbox = false) => {
			this.submitWithToken(token, withCheckbox);
		});
	}

	submitWithToken(token, withCheckbox) {
		this.setHiddenInput('recaptcha_token', token);
		this.setHiddenInput('recaptcha_checkbox', withCheckbox);
		this.form.submit();
	}

	handleReviewChange(event) {
		console.log('handleReviewChange');
		this.originalLanguage = null;
		this.originalReviewText = event.target.value;
		if (event.target.value.trim().length >= this.minTextLength) {
			event.target.parentNode.querySelector('.ai-badge').style.display = 'inline-block';
		} else {
			event.target.parentNode.querySelector('.ai-badge').style.display = 'none';
			this.toggleAiTitleButton(false);
		}
	}

	handleReviewChanged(event) {
		console.log('handleReviewChanged');
		const textValue = this.form.querySelector(this.reviewInputSelector).value;
		const reviewTitle = this.form.querySelector(this.titleInputSelector).value;
		if (textValue.trim().length >= this.minTextLength && reviewTitle.length === 0 && !this.isLoading) {
			this.toggleAiTitleButton(true);
		} else {
			this.toggleAiTitleButton(false);
		}
	}

	requestAiAssist(event) {
		event.preventDefault();
		this.isLoading = true;
		this.toggleAiTitleButton(false);

		if (event.target.classList.contains('disabled')) {
			return;
		}

		this.toggleAiAnimation(true);

		const url = `${getPublicUrl()}/api/review/${this.form.dataset.company}/ai/assist`;
		const formData = new FormData(this.form);
		const data = {
			'rating': formData.get('rating'),
			'text': this.originalReviewText,
			'language': this.originalLanguage,
		};

		this.reCaptchaService.runWithCaptcha("company_review_ai", (token, withCheckbox = false) => {
			data.recaptcha_token = token;
			data.recaptcha_checkbox = withCheckbox;

			return axios.put(url, data)
				.then((response) => {
					console.log("company_review_ai_assist", response);

					if (this.originalLanguage === null) {
						this.originalLanguage = response.data.language;
					}
					this.reviewLanguage = response.data.language;
					this.form.querySelector(this.reviewInputSelector).value = response.data.review;
					this.form.querySelector(this.titleInputSelector).value = response.data.title;
					this.toggleAiAnimation(false);
					this.isLoading = false;
					this.setUsedAi('rewrite');
				})
				.catch((error) => {
					console.error("company_review_ai_assist", error);
					this.toggleAiAnimation(false);
					this.isLoading = false;

					if (error.status === 429) {
						event.target.disabled = true;
						event.target.classList.add('disabled');
						event.target.setAttribute('data-bs-original-title', 'Too many requests. Please try again later.');
					}
				});
		});
	}

	requestAiSummarize(event) {
		event.preventDefault();

		if (event.target.classList.contains('disabled')) {
			return;
		}

		this.toggleAiAnimation(true, event.target);

		const url = `${getPublicUrl()}/api/review/${this.form.dataset.company}/ai/summarize`;
		const formData = new FormData(this.form);
		const data = {
			'rating': formData.get('rating'),
			'text': this.originalReviewText,
			'language': this.originalLanguage,
		};

		this.reCaptchaService.runWithCaptcha("company_review_ai", (token, withCheckbox = false) => {
			data.recaptcha_token = token;
			data.recaptcha_checkbox = withCheckbox;

			return axios.put(url, data)
				.then((response) => {
					console.log("company_review_ai_summarize", response);

					if (this.originalLanguage === null) {
						this.originalLanguage = response.data.language;
					}
					this.reviewLanguage = response.data.language;
					this.form.querySelector('[name="title"]').value = response.data.title;
					this.toggleAiAnimation(false, event.target);
					this.toggleAiTitleButton(false);
					this.setUsedAi('title');
				})
				.catch((error) => {
					console.error("company_review_ai_summarize", error);
					this.toggleAiAnimation(false, event.target);

					if (error.status === 429) {
						event.target.disabled = true;
						event.target.classList.add('disabled');
						event.target.setAttribute('data-bs-original-title', 'Too many requests. Please try again later.');
					}
				});
		});
	}

	toggleLoadingAnimation(isLoading) {
		console.log('toggleLoadingAnimation', isLoading, this.btn);
		if (isLoading) {
			this.btn.classList.add('loading');
			this.btn.disabled = true;
		} else {
			this.btn.classList.remove('loading');
			this.btn.disabled = false;
		}
	}

	toggleAiAnimation(isLoading, btn = null) {
		console.log('toggleLoadingAnimation', isLoading);
		if (!btn) {
			btn = this.form.querySelector('.ai-badge');
		}

		isLoading ? btn.classList.add('loading') : btn.classList.remove('loading');
	}

	toggleAiTitleButton(show) {
		if (show) {
			this.form.querySelector(this.titleInputSelector + ' + .ai-badge').style.display = 'inline-block';
			this.form.querySelector(this.titleInputSelector).style['padding-right'] = '95px';
		} else {
			this.form.querySelector(this.titleInputSelector + ' + .ai-badge').style.display = 'none';
			this.form.querySelector(this.titleInputSelector).style['padding-right'] = '0px';
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new Review();
});